import axios from 'axios';

import { BlockingStep, ErrorCode } from '@activepieces/shared';

// Defensive fallback: when the backend rejects an activation with
// FLOW_CONTAINS_LOCKED_PIECES (e.g. the UI guard didn't catch it, or a race),
// surface the blocking pieces so the caller can (re)open the same modal.
// Returns null when it isn't that error or carries no pieces (never open an empty modal).
export function getLockedPiecesFromError(error: Error): BlockingStep[] | null {
  if (!axios.isAxiosError(error)) {
    return null;
  }
  const data = error.response?.data as
    | { code?: string; params?: { pieces?: BlockingStep[] } }
    | undefined;
  if (data?.code !== ErrorCode.FLOW_CONTAINS_LOCKED_PIECES) {
    return null;
  }
  const pieces = data.params?.pieces;
  return pieces && pieces.length > 0 ? pieces : null;
}
